import { Input, Select, Tag, Row, Col } from "antd";
export const costExceptionTabTableColumns = (customerUidData, logisticsService) => {
    return [
        {
            title: 'Tracking Number',
            dataIndex: ['billing_detail', 'tracking_id'],
            key: 'tracking_id',
            fixed: 'left',
            search: true,
            renderFormItem: (item, { type, defaultRender, ...rest }) => {
                return <Input placeholder="请输入(支持模糊查询)" allowClear />
            },
        },
        {
            title: 'UID',
            dataIndex: ['billing_detail', 'customer', 'uid'],
            key: 'uid',
            fixed: 'left',
            search: true,
            renderFormItem: (item, { type, defaultRender, ...rest }) => {
                return <Select
                    showSearch
                    allowClear
                    placeholder="请选择"
                    filterOption={(input, option) => {
                        return option.label.toLowerCase().includes(input.toLowerCase());
                    }}
                    optionFilterProp="children"
                    options={
                        customerUidData?.map((item) => {
                            return {
                                label: item.uid,
                                value: item.id,
                            }
                        })
                    }
                    style={{
                        textAlign: 'left',
                    }}
                    />
            },
        },
        {
            title: '导入批次编号',
            dataIndex: ['billing_invoice', 'name'],
            key: 'billing_invoice_name',
            fixed: 'left',
            search: true,
            renderFormItem: (item, { type, defaultRender, ...rest }) => {
                return <Input placeholder="请输入(支持模糊查询)" allowClear />
            },
        },
        {
            title: 'Shipment Date',
            dataIndex: ['billing_detail', 'shipment_date'],
            key: 'shipment_date',
            search: false,
        },
        {
            title: 'Service',
            dataIndex: ['billing_detail', 'logistics_service', 'name'],
            key: 'logistics_service',
            search: false,
        },
        {
            title: 'Ground Service',
            dataIndex: ['billing_detail', 'rate_json', 'Grd Svc'],
            key: 'ground_service',
            search: false,
        },
        {
            title: 'Bill Weight',
            dataIndex: ['billing_detail', 'rate_json', 'Bill Wt'],
            key: 'bill_weight',
            search: false,
        },
        {
            title: 'Region',
            dataIndex: ['billing_detail', 'rate_json', 'Region'],
            key: 'region',
            search: false,
        },
        {
            title: 'Charge 1',
            dataIndex: ['billing_detail', 'rate_json', 'Chrg 1'],
            key: 'chrg_1',
            search: false,
        },
        {
            title: 'Freight Amount',
            dataIndex: ['billing_detail', 'rate_json', 'Freight Amt'],
            key: 'freight_amount',
            search: false,
        },
        {
            title: 'Charge 2',
            dataIndex: ['billing_detail', 'rate_json', 'Chrg 2'],
            key: 'chrg_2',
            search: false,
        },
        {
            title: 'Volume Discount Amount',
            dataIndex: ['billing_detail', 'rate_json', 'Vol Disc Amt'],
            key: 'volume_discount_amount',
            search: false,
        },
        {
            title: 'Charge 3',
            dataIndex: ['billing_detail', 'rate_json', 'Chrg 3'],
            key: 'chrg_3',
            search: false,
        },
        {
            title: 'Earned Discount Amount',
            dataIndex: ['billing_detail', 'rate_json', 'Earned Disc Amt'],
            key: 'earned_discount_amount',
            search: false,
        },
        {
            title: 'Charge 4',
            dataIndex: ['billing_detail', 'rate_json', 'Chrg 4'],
            key: 'chrg_4',
            search: false,
        },
        {
            title: 'Automation Discount Amount',
            dataIndex: ['billing_detail', 'rate_json', 'Auto Disc Amt'],
            key: 'automation_discount_amount',
            search: false,
        },
        {
            title: 'Charge 5',
            dataIndex: ['billing_detail', 'rate_json', 'Chrg 5'],
            key: 'chrg_5',
            search: false,
        },
        {
            title: 'Performance Pricing Disc',
            dataIndex: ['billing_detail', 'rate_json', 'Perf Price Amt'],
            key: 'performance_pricing_discount',
            search: false,
        },
        {
            title: 'Charge 6',
            dataIndex: ['billing_detail', 'rate_json', 'Chrg 6'],
            key: 'chrg_6',
            search: false,
        },
        {
            title: 'Fuel Surcharge Amount',
            dataIndex: ['billing_detail', 'rate_json', 'Fuel Amt'],
            key: 'fuel_surcharge_amount',
            search: false,
        },
        {
            title: 'Charge 7',
            dataIndex: ['billing_detail', 'rate_json', 'Chrg 7'],
            key: 'chrg_7',
            search: false,
        },
        {
            title: 'Residential Charge Amount',
            dataIndex: ['billing_detail', 'rate_json', 'Resi Amt'],
            key: 'residential_charge_amount',
            search: false,
        },
        {
            title: 'Charge 8',
            dataIndex: ['billing_detail', 'rate_json', 'Chrg 8'],
            key: 'chrg_8',
            search: false,
        },
        {
            title: 'Delivery Area Surcharge Amount',
            dataIndex: ['billing_detail', 'rate_json', 'DAS Amt'],
            key: 'delivery_area_surcharge_amount',
            search: false,
        },
        {
            title: 'Charge 9',
            dataIndex: ['billing_detail', 'rate_json', 'Chrg 9'],
            key: 'chrg_9',
            search: false,
        },
        {
            title: 'On-Call Pickup Amount',
            dataIndex: ['billing_detail', 'rate_json', 'On-Call Amt'],
            key: 'on_call_pickup_amount',
            search: false,
        },
        {
            title: 'Charge 10',
            dataIndex: ['billing_detail', 'rate_json', 'Chrg 10'],
            key: 'chrg_10',
            search: false,
        },
        {
            title: 'Declared Value Amount',
            dataIndex: ['billing_detail', 'rate_json', 'D.V. Amt'],
            key: 'declared_value_amount',
            search: false,
        },
        {
            title: 'Charge 11',
            dataIndex: ['billing_detail', 'rate_json', 'Chrg 11'],
            key: 'chrg_11',
            search: false,
        },
        {
            title: 'Signature Service Amount',
            dataIndex: ['billing_detail', 'rate_json', 'Sign Svc Amt'],
            key: 'signature_service_amount',
            search: false,
        },
        {
            title: 'Charge 12',
            dataIndex: ['billing_detail', 'rate_json', 'Chrg 12'],
            key: 'chrg_12',
            search: false,
        },
        {
            title: 'Saturday Charge Amount',
            dataIndex: ['billing_detail', 'rate_json', 'Sat Amt'],
            key: 'saturday_charge_amount',
            search: false,
        },
        {
            title: 'Charge 13',
            dataIndex: ['billing_detail', 'rate_json', 'Chrg 13'],
            key: 'chrg_13',
            search: false,
        },
        {
            title: 'Additional Handling Amount',
            dataIndex: ['billing_detail', 'rate_json', 'Addn Hndlg Amt'],
            key: 'additional_handling_amount',
            search: false,
        },
        {
            title: 'Charge 14',
            dataIndex: ['billing_detail', 'rate_json', 'Chrg 14'],
            key: 'chrg_14',
            search: false,
        },
        {
            title: 'Address Correction Amount',
            dataIndex: ['billing_detail', 'rate_json', 'Adr Corr Amt'],
            key: 'address_correction_amount',
            search: false,
        },
        {
            title: 'Charge 15',
            dataIndex: ['billing_detail', 'rate_json', 'Chrg 15'],
            key: 'chrg_15',
            search: false,
        },
        {
            title: 'GST Charge Amount',
            dataIndex: ['billing_detail', 'rate_json', 'GST Amt'],
            key: 'gst_charge_amount',
            search: false,
        },
        {
            title: 'Charge 16',
            dataIndex: ['billing_detail', 'rate_json', 'Chrg 16'],
            key: 'chrg_16',
            search: false,
        },
        {
            title: 'Original Duty Charge Amount',
            dataIndex: ['billing_detail', 'rate_json', 'Duty Amt'],
            key: 'original_duty_charge_amount',
            search: false,
        },
        {
            title: 'Charge 17',
            dataIndex: ['billing_detail', 'rate_json', 'Chrg 17'],
            key: 'chrg_17',
            search: false,
        },
        {
            title: 'Duty Advancement Fee Charge',
            dataIndex: ['billing_detail', 'rate_json', 'Adv Fee Amt'],
            key: 'duty_advancement_fee_charge',
            search: false,
        },
        {
            title: 'Charge 18',
            dataIndex: ['billing_detail', 'rate_json', 'Chrg 18'],
            key: 'chrg_18',
            search: false,
        },
        {
            title: 'Original VAT Amount',
            dataIndex: ['billing_detail', 'rate_json', 'Orig VAT Amt'],
            key: 'original_vat_amount',
            search: false,
        },
        {
            title: 'Charge 19',
            dataIndex: ['billing_detail', 'rate_json', 'Chrg 19'],
            key: 'chrg_19',
            search: false,
        },
        {
            title: 'Misc Charge 1 Amount',
            dataIndex: ['billing_detail', 'rate_json', 'Misc 1 Amt'],
            key: 'misc_charge_1_amount',
            search: false,
        },
        {
            title: 'Charge 20',
            dataIndex: ['billing_detail', 'rate_json', 'Chrg 20'],
            key: 'chrg_20',
            search: false,
        },
        {
            title: 'Misc Charge 2 Amount',
            dataIndex: ['billing_detail', 'rate_json', 'Misc 2 Amt'],
            key: 'misc_charge_2_amount',
            search: false,
        },
        {
            title: 'Charge 21',
            dataIndex: ['billing_detail', 'rate_json', 'Chrg 21'],
            key: 'chrg_21',
            search: false,
        },
        {
            title: 'Misc Charge 3 Amount',
            dataIndex: ['billing_detail', 'rate_json', 'Misc 3 Amt'],
            key: 'misc_charge_3_amount',
            search: false,
        },
        {
            title: 'calculation_error',
            dataIndex: 'calculation_error',
            key: 'calculation_error',
            search: false,
            fixed: 'right',
        }
    ]
}
